import { CalendarDaysIcon, FolderOpenIcon, SparklesIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  value: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 100 Proyectos de Biblioteca Escolar Listos para Adaptar',
    description:
      '100 proyectos bibliotecarios completamente formulados y listos para adaptar al contexto de cualquier escuela de Argentina. Organizados en 10 categorías: promoción de lectura, alfabetización informacional, inclusión digital, mediación comunitaria, patrimonio escolar, literacidad digital, ciudadanía digital, recursos educativos, innovación bibliotecaria y proyectos interdisciplinarios. Cada proyecto incluye objetivo general, objetivos específicos, actividades, destinatarios, cronograma, recursos necesarios, indicadores de evaluación y variantes de adaptación.',
    value: '$18.000 ARS',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: '100 Recursos y Herramientas para la Gestión Bibliotecaria',
    description:
      'Softwares bibliotecarios recomendados (Koha, Pergamino, Bibliofacil), plataformas de gestión de colecciones, herramientas de catalogación profesionales, aplicaciones móviles para bibliotecas, bases de datos de acceso libre (JSTOR Daily, Archive.org, Project Gutenberg, OpenAlex), plantillas de trabajo editables, formularios administrativos completos, sistemas de evaluación bibliométrica, integraciones tecnológicas, guías de digitalización y tutoriales de implementación.',
    value: '$15.000 ARS',
    icon: WrenchIcon,
  },
  {
    number: '03',
    title: '100 Propuestas de Animación y Promoción de la Lectura',
    description:
      'Booktubers escolares, encuentros literarios temáticos, desafíos de lectura comunitarios, lecturas dramatizadas, club de lectura digital, cafés literarios en la biblioteca, maratones de lectura de 24 horas, booktok escolar, bookbox temáticos, adaptaciones audiovisuales de clásicos, espacios de lectura inmersiva, instalaciones artísticas con libros, campaña #BibliotecaQueResuena, tertulias dialógicas, mediaciones personalizadas y encuentros virtuales con autores argentinos.',
    value: '$15.000 ARS',
    icon: SparklesIcon,
  },
  {
    number: '04',
    title: 'Calendario Bibliotecario 2026 — Efemérides, Campañas y Propuestas Mes a Mes',
    description:
      'Fechas conmemorativas literarias internacionales, días internacionales de bibliotecas y lectura, campañas mensuales sugeridas con actividades específicas, cronograma de eventos destacados, conexiones con el calendario escolar argentino, planilla editable para personalizar según tu institución, propuestas para cada mes del año y links a recursos e iniciativas conmemoradas.',
    value: '$20.000 ARS',
    icon: CalendarDaysIcon,
  },
];
